export enum WathiqStatusEnums {
  PENDING = 'pending', // After entering valid CR, during success/preview/form
  CREATED = 'created', // Loading state from BE, treated same as PENDING
  COMPLETED = 'completed', // Form submitted, cannot access any wathiq screens
  FAILED = 'failed', // Service failed, show error, can retry
  DISCARDED = 'discarded', // User clicked "data is not correct", can start over
}
